import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { Skeleton } from '@material-ui/lab';
import {
  Grid,
  Card,
  Icon
} from '@material-ui/core';
import NumberFormat from 'react-number-format';


const AboutUs = () => {
  const history = useHistory();
  const {isLoading} = useSelector((state: IReduxState) => state.home);
  const {
    customers_count,
    orders_count,
    life_time_sales,
    average_sales
  } = useSelector((state: IReduxState) => state.home.storeStatistic);
  const {profile} = useSelector((state: IReduxState) => state.user);
  const permissions = profile?.config?.permissions || {};

  const aboutUsStatisticList = [
    {
      count: customers_count,
      isPermission: permissions?.customersList,
      title: 'Total Account Holders',
      icon: 'groups',
      isPrice: false,
      path: '/customers/list'
    },
    {
      count: orders_count,
      isPermission: permissions?.orders,
      title: 'Total Orders',
      icon: 'receipt',
      isPrice: false,
      path: '/orders/list'
    },
    {
      count: life_time_sales?.toFixed(2),
      isPermission: permissions?.orders,
      title: 'Total Sales',
      icon: 'credit_card',
      isPrice: true,
      path: '/orders/list'
    },
    {
      count: average_sales?.toFixed(2),
      isPermission: permissions?.orders,
      title: 'Average Order',
      icon: 'calculate',
      isPrice: true,
      path: '/orders/list'
    }
  ];

  return (
    <>
      {aboutUsStatisticList.map((item) => (
        <Grid key={item.title} item md={3} sm={6} xs={12}>
          <Card
            elevation={3}
            className={clsx('p-8 flex-column justify-center items-center ml-2 m-2', item.isPermission && 'cursor-pointer')}
            onClick={() => (item.isPermission && history.push(item.path))}
          >
            {isLoading ?
              <>
                <Skeleton animation="wave" variant="rect" width={25} height={25} />
                <div className="flex-column justify-center items-center w-full max-w-80full">
                  <Skeleton animation="wave" variant="text" height={35} className="w-full" />
                  <Skeleton animation="wave" variant="text" component="p" className="w-full max-w-50full" />
                </div>
              </>
              :
              <>
                <Icon className="text-muted" >
                  {item.icon}
                </Icon>
                <div className="flex-column justify-center items-center">
                  <h3 className="mt-1 text-32">
                    {item.isPrice ?
                      <NumberFormat
                        fixedDecimalScale
                        decimalScale={2}
                        value={item.count}
                        displayType="text"
                        thousandSeparator
                        prefix="$"
                      /> :
                      item.count
                    }
                  </h3>
                  <p className="m-0 text-muted">{item.title}</p>
                </div>
              </>
            }
          </Card>
        </Grid>
      ))
      }

    </>
  );
};

export default AboutUs;
